import { render, staticRenderFns } from "./CustomerMaterialPriceList.vue?vue&type=template&id=46a73615&scoped=true&"
import script from "./CustomerMaterialPriceList.vue?vue&type=script&lang=js&"
export * from "./CustomerMaterialPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a73615",
  null
  
)

export default component.exports